import { ReactComponent as IcoMonitoring } from 'src/assets/images/icons/ic_analytics.svg';
import { ReactComponent as IcoManagement } from 'src/assets/images/icons/ic_blog.svg';
import { ReactComponent as IcoReport } from 'src/assets/images/icons/ic_chart.svg';
import { ReactComponent as IcoSetting } from 'src/assets/images/icons/ic_setting.svg';

import { PATH_ROOT } from '../../../routes/paths';
// ----------------------------------------------------------------------

const navConfig = [
  {
    path: PATH_ROOT.monthlyReport.root,
    title: '월간 리포트',
    enTitle: 'MONTHLY REPORT',
    icon: IcoReport,
    isAdmin: false,
  },
  {
    path: PATH_ROOT.monitoring.root,
    title: '모니터링',
    enTitle: 'MONITORING',
    icon: IcoMonitoring,
    isAdmin: false,
  },
  {
    path: PATH_ROOT.management.root,
    title: '관리',
    enTitle: 'MANAGEMENT',
    icon: IcoSetting,
    isAdmin: true,
    children: [
      {
        title: '인프라 구성도 관리',
        path: PATH_ROOT.management.infraImage,
        icon: IcoManagement,
      },
      {
        title: '서비스 내역',
        path: PATH_ROOT.management.service,
        icon: IcoManagement,
      },
      {
        title: '계정 / VM / IP 관리',
        path: PATH_ROOT.management.accVmIp,
        icon: IcoManagement,
      },
      {
        title: '인프라 관리',
        path: PATH_ROOT.management.infra,
        icon: IcoManagement,
      },
      // {
      //   title: '메뉴권한관리',
      //   path: PATH_ROOT.management.menu,
      // },
      // {
      //   title: '부서관리',
      //   path: PATH_ROOT.management.dept,
      // },
      // {
      //   title: '시스템설정',
      //   path: PATH_ROOT.management.setting,
      // },
    ],
  },
];

export default navConfig;
